<template>
    <div class="modal" v-if="isVisible">
      <div class="modal-overlay" @click="hide"></div>
      <div :class="fullScreenClass">
        <header class="modal-header">
            <div class="modal-title">
                <h3>{{ title }}</h3>
            </div>
            <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null"
            style="background: rgb(255, 255, 255);" 
            @click="hide"> close </i>
        </header>
        <div class="modal-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  
  export default {
    name: 'vx-modal',
    props: {
        isFullScreen : {
            type: Boolean,
            default: false
        },
        active: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isVisible: this.active
        }
    },
    computed: {
        fullScreenClass() {
            return this.isFullScreen ? 'modal-container modal-full-screen' : 'modal-container'
        }
    },
    methods: {
        hide() {
            this.isVisible = !this.isVisible;
            this.$emit('update:active', this.isVisible)
            this.$emit('close')            
        }
    }
  }
  </script>
  
  <style>
    .modal {
        left: 0;
        -webkit-transition: all .2s;
        transition: all .2s;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        z-index: 99999;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        opacity: 1;
    }

    .modal-overlay {
        width: 100%;
        background: rgba(0,0,0,.4);
        position: absolute;
        top: 0;
        height: 100%;
        z-index: 10;
        -webkit-transition: all .25s ease;
        transition: all .25s ease;
        opacity: 1;
    }
    
    .modal-container {
        -webkit-transition: all .2s;
        transition: all .2s;
        z-index: 999999;
        width: 600px;
        margin: 10px;
        max-width: calc(100% - 30px);
        max-height: calc(100% - 30px);
        border-radius: 6px;
        -webkit-box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
        box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
        background: #fff;
        -webkit-animation: rebound .3s;
        animation: rebound .3s;
    }

    .modal-full-screen {
        width: 100%;
        height: 100%;
    }
    
    .modal-header {
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        background: rgba(0,0,0,.05);
        border-radius: 5px 5px;
        position: relative;
    }

    .modal-title {
        width: 100%;
        position: relative;
        overflow: hidden;
        border-radius: 5px 5px 0 0;
    }

    .modal-title h3{
        -webkit-transition: all .23s ease .1s;
        transition: all .23s ease .1s;
        padding: 8px;
        padding-left: 12px;
        font-size: 1.2rem;
    }
    
    .modal-close {
        border: none;
        background-color: transparent;
        font-size: 30px;
        cursor: pointer;
    }
    
    .modal-body {
        padding: 13px;
        font-size: .9em;
        -webkit-transition: all .23s ease .1s;
        transition: all .23s ease .1s;
        overflow: auto;
        max-height: calc(100vh - 100px);
        margin-top: 5px;
        margin-bottom: 5px;
        width: calc(100% - 5px);
        height: inherit;
        margin-right: 5px;
        font-size: 1rem;
        padding: 1rem;
    }
  </style>